export const RANGE_LIMITS = {
  PAGE: 604,
  JUZ: 30,
};

export const DEFAULT_RANGE_VALUES = {
  page: { start: 3, end: 4 },
  juz: { start: 1, end: 1 },
  key: {
    startChapter: 1,
    startVerse: 1,
    endChapter: 1,
    endVerse: 7,
  },
};

export const TEST_MODES = {
  WORDS: 'words',
  VERSES: 'verses',
};

export const RANGE_TYPES = {
  JUZ: 'juz',
  PAGE: 'page',
  KEY: 'key',
};
